module.exports = __webpack_public_path__ + "static/media/wiz.6bd9d10a.png";